export default {"src":"/nachrichten/_next/static/media/icons-system-sprite.33719ea7.svg","height":10,"width":10,"blurWidth":0,"blurHeight":0};